import { generateTestId } from "@client-shared";

export const setOnboardingLayoutTestId = (identifier: string): string =>
  generateTestId("OnboardingLayout", identifier);
